import { Component, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate, keyframes } from '@angular/animations';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { Observable } from "rxjs/Observable";

import { MainConfig, AuthService, FormToolsService } from '../../core';

@Component({
  selector: 'login-screen',
  templateUrl: './login-screen.component.html',
  styleUrls: ['./login-screen.component.scss'],
  animations: [
    trigger('show', [
      transition('* => *', [
        animate('800ms ease-in-out', keyframes([
          style({ opacity: 0, transform: 'scale(0,0)', offset: 0}),
          style({ opacity: 1, transform: 'scale(1.1,1.1)', offset: 0.6}),
          style({ transform: 'scale(0.9,0.9)', offset: 0.9}),
          style({ transform: 'scale(1,1)', offset: 1.0})
        ]))
      ])
    ])
  ]
})
export class LoginScreenComponent implements OnInit {
  name: string = '';
  logo: string = '';
  logoHeight: string = '';
  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    public ft: FormToolsService,
    private router: Router,
    private mainConfig: MainConfig,
    private authService: AuthService
  ) {
    this.name = mainConfig.cmsName;
    this.logo = mainConfig.topBarLogo;
    this.logoHeight = mainConfig.topBarLogoHeight;    
  }

  ngOnInit() {
    if (this.authService.isLoggedIn) {
      this.router.navigate(['']);
    }

    this.form = this.fb.group({
      email: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  login() {
    let emailField = this.form.get('email');
    let passwordField = this.form.get('password');

    emailField.setErrors({ 'noExist': null });
    passwordField.setErrors({ 'incorrect': null });

    this.authService.login(emailField.value, passwordField.value).subscribe(
      response => {
        this.router.navigate(['']);
      },

      error => {
        if (typeof error.errorCode != 'undefined')
          if (error.errorCode == 1) {
            emailField.setErrors({ 'noExist': true });
          } else if (error.errorCode == 2) {
            passwordField.setErrors({ 'incorrect': true });
          }
        else {
          console.log(error.message);
        }
      }
    );
  }

  detectEnter(e) {
    if (e.keyCode == 13) {
      this.login();
    }
  }
}


// WEBPACK FOOTER //
// ./libs/atenea-cms/src/login/login-screen/login-screen.component.ts